import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import "./TeacherClassPage.css";

import logo from "../../images/logo.png";
import TeacherBadge from "../badge/TeacherBadge";
import StudentsTable from "./students_table/StudentsTable";

function TeacherClassPage() {
  return (
    <>
      <Container className="head_purp" fluid>
        <Row>
          <Col sm={2}></Col>
          <Col sm={2}>
            Електронні додатки "Грамота"
            <div className="logo">
              <a href="/home">
                <img alt="logo" src={logo} style={{ width: "50%" }} />
              </a>
            </div>
          </Col>
          <Col> </Col>

          <Col sm={3}>
            <div>Інструкція Служба підтримки</div> <br />
            <div>
              Ви увійшли як <TeacherBadge />
            </div>
            <div> Кравченко Інна Степанівна</div>
          </Col>
          <Col sm={2}></Col>
        </Row>
      </Container>

      <Container className="con_purp" fluid>
        <Row>
          <Col>
            <br />
          </Col>
        </Row>
        <Row>
          <Col sm={4}></Col>
          <Col>
            <StudentsTable />
          </Col>
          <Col sm={4}></Col>
        </Row>
      </Container>
    </>
  );
}

export default TeacherClassPage;
